import React, { Component } from "react";
import AudioPlayer from "../../../common/helpers/AudioPlayer";
import TalentSamplesManageButton from "./TalentSamplesManageButton";

class SamplesBox extends Component {
  render() {
    const config = {},
      tracks = {};
    let styles =
      /* SVG file with control buttons */
      +'.mejs__overlay-button {background-image: url("/assets/images/mejs-controls.svg") !important;}' +
      '.mejs__overlay-loading-bg-img {background-image: url("/assets/images/mejs-controls.svg") !important;}' +
      '.mejs__button > button {background-image: url("/assets/images/mejs-controls.svg") !important;}' +
      /*MediaElementJs customizations */
      '.mejs__container, .mejs__controls:not([style*="display: none"]) {background: transparent;}' +
      /*Texts*/
      ".mejs__time {color: #ff5402;}" +
      /*Time scale*/
      ".mejs__time-rail .mejs__time-total {background: #e0e0e0;}" +
      ".mejs__time-rail .mejs__time-buffering {background: #ff5402;}" +
      ".mejs__time-rail .mejs__time-loaded {background: #e0e0e0;}" +
      ".mejs__time-rail .mejs__time-current {background: #ff5402;}" +
      /*Time scale circle handle*/
      ".mejs__time-handle-content {border: 4px solid #b23a01;}" +
      ".mejs__time-current, .mejs__time-handle-content {background: #ff651b;}" +
      /*Volume control*/
      ".mejs__horizontal-volume-current {background: #ff5402;}" +
      ".mejs__horizontal-volume-total {background: #e0e0e0;}";
    return (
      <React.Fragment>
        <div className={`widget ${this.props.classColumn}`}>
          <div className="title">Talent samples</div>
          <div className="row">
            <style>{styles}</style>
            <div className="col">
              {!this.props.profileData.Samples ||
                (this.props.profileData.Samples.length == 0 && (
                  <div className="row">
                    <div className="col">Talent has not uploaded any voice samples</div>
                  </div>
                ))}
              {this.props.profileData.Samples &&
                this.props.profileData.Samples.map((sample, index) => {
                  let sources = [{ src: sample.FileUrl, type: "audio/mpeg" }];
                  return (
                    <div key={index} className="mb-2">
                      <div className="row">
                        <div className="col">
                          {this.props.profileData.ProfileType == "Singer" && <i className="ion-icon ion-icon-1x ion-music-note sample-icon" />}
                          {this.props.profileData.ProfileType == "VoiceActor" && <i className="ion-icon ion-icon-1x ion-mic-a sample-icon" />}
                          <a href={sample.FileUrl} className="ml-1">
                            {sample.FileName}
                          </a>
                          <br />
                          <span className="ml-3">
                            <small>Added: {sample.CreatedOn}</small>
                          </span>
                          <span className="ml-3">
                            <small>Updated: {sample.ModifiedOn}</small>
                          </span>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <AudioPlayer id={"player" + index} preload="metadata" width="100%" sources={JSON.stringify(sources)} options={JSON.stringify(config)} tracks={JSON.stringify(tracks)} />
                        </div>
                      </div>
                    </div>
                  );
                })}
              <div>
                {this.props.profileData.UserSamplesLink ? <span>Link </span> : <span>Link not available</span>}
                {this.props.profileData.UserSamplesLinkExpirationData && <span>valid until {this.props.profileData.UserSamplesLinkExpirationData}</span>}
              </div>
              <TalentSamplesManageButton profileData={this.props.profileData} skillVendorId={this.props.skillVendorId} />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SamplesBox;
